<h3 mat-dialog-title>Export {{ data.type }}</h3>
<form [formGroup]="downloadForm">
  <div mat-dialog-content>
    <div class="formRow">
      <span class="label">Name:</span>
      <span class="field">
        <mat-form-field style="width: 100%" appearance="fill">
          <input matInput formControlName="name" />
        </mat-form-field>
      </span>
    </div>
    <div class="formRow">
      <span class="label">Type:</span>
      <span class="field">
        <mat-form-field style="width: 100%" appearance="fill">
          <mat-select formControlName="type">
            <ng-container *ngFor="let option of exportOptions">
              <mat-option value="{{ option.value }}">{{
                option.title
              }}</mat-option>
            </ng-container>
          </mat-select>
        </mat-form-field>
      </span>
    </div>
    <div class="note" *ngIf="showMessage">
      NOTE: YOU HAVE UNSAVED CHANGES, CLICK save & export TO GET THE LATEST DATA
      INCLUDED IN YOUR export.
    </div>
  </div>
  <div mat-dialog-actions align="end">
    <button mat-button mat-dialog-close class="button_small cancel">
      cancel
    </button>
    <button
      mat-button
      *ngIf="!showMessage"
      (click)="onConfirmClick()"
      class="button_small"
      [disabled]="!downloadForm.valid"
      tabindex="-1"
    >
      export
    </button>
    <button
      mat-button
      *ngIf="showMessage"
      (click)="saveAndExport()"
      class="button_small"
      [disabled]="!downloadForm.valid"
      tabindex="-1"
    >
      save & export
    </button>
  </div>
</form>
